
export default {
  altitudePreview: {
    'expandAltitudeChart': 'Ampliar el gráfico',
    'altitude': 'Altitud'
  }
}
